import { StatusOption } from '../../utils'

export enum PdfTypeEnum {
  DESTINEO = 'DESTINEO',
  STANDARD = 'STANDARD'
}

export const pdfTypeEnumMapping: Record<PdfTypeEnum, StatusOption> = {
  [PdfTypeEnum.DESTINEO]: {
    label: 'Catalogue 4'
  },
  [PdfTypeEnum.STANDARD]: {
    label: 'Standard'
  }
}
